
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/docs/underwriting",
      function () {
        return require("private-next-pages/docs/underwriting.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/docs/underwriting"])
      });
    }
  